<template>  
    <figure @click="$emit('emClicked')">
        <img :src="img" alt="">
        <figcaption 
                v-if="caption" 
                v-html="caption" 
                :class="{animate}" />
    </figure>  
</template>

<script>
export default {
    props: {
        img: {
            type: String
        },
        caption: {
            type: [String,Boolean],
            default: false
        },
        animate: {
            type: Boolean,
            default: false
        }
    }
}
</script>